import type { ReactNode } from 'react'
import React from 'react'

import * as S from './AnalyticsToolbar.styled'

export type AnalyticsToolbarProps = {
  children: ReactNode
  actions?: ReactNode
  bottomContent?: ReactNode
}

export const AnalyticsToolbar = ({ children, actions, bottomContent }: AnalyticsToolbarProps) => {
  return (
    <S.Container>
      <S.Inner>
        <S.Tools>{children}</S.Tools>
        <S.Actions>{actions}</S.Actions>
      </S.Inner>
      {bottomContent}
    </S.Container>
  )
}
